/* Mocha – skrypty motywu */
(function () {
  'use strict';

  var theme = window.theme || { moneyFormat: '{{amount_with_comma_separator}} zł', routes: { root: '/', cart: '/cart', cartAdd: '/cart/add' }, afterAdd: 'cart', strings: {} };

  function define(name, ctor) { if (!customElements.get(name)) customElements.define(name, ctor); }

  /* ---------- Formatowanie ceny wg ustawień sklepu (np. „52,95 zł”) ---------- */
  function formatMoney(cents) {
    cents = Math.round(cents);
    var fmt = theme.moneyFormat || '{{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var num = (n / 100).toFixed(precision).split('.');
      var whole = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (num[1] ? decimal + num[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Licznik do końca promocji (prawdziwa data) ---------- */
  function initCountdowns(root) {
  (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
    if (el.dataset.cdInit) return;
    el.dataset.cdInit = '1';
    var raw = (el.dataset.countdown || '').trim();
    var pl = raw.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})(?:[ T,]+(\d{1,2})[:.](\d{2}))?$/);
    var end = pl
      ? new Date(+pl[3], +pl[2] - 1, +pl[1], pl[4] ? +pl[4] : 23, pl[5] ? +pl[5] : 59, 59)
      : new Date(raw.replace(' ', 'T'));
    var out = el.querySelector('[data-countdown-value]');
    if (isNaN(end.getTime())) return;
    function tick() {
      var diff = Math.floor((end - new Date()) / 1000);
      if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (el.dataset.countdownStyle === 'boxes') {
        el.querySelectorAll('[data-cd-days]').forEach(function (x) { x.hidden = d === 0; });
        el.querySelector('[data-cd-d]').textContent = d;
        el.querySelector('[data-cd-h]').textContent = pad(h);
        el.querySelector('[data-cd-m]').textContent = pad(m);
        el.querySelector('[data-cd-s]').textContent = pad(s);
      } else {
        out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      el.hidden = false;
    }
    var timer = setInterval(tick, 1000);
    tick();
  });
  }
  initCountdowns();

  /* ---------- Galeria ---------- */
  define('product-gallery', class extends HTMLElement {
    connectedCallback() {
      var main = this.querySelector('.gallery__main-img');
      var list = this.querySelector('[data-thumbs]');
      var thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main && main.tagName === 'IMG') { main.removeAttribute('srcset'); main.src = btn.dataset.src; main.alt = btn.dataset.alt || ''; }
          thumbs.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
      var step = function (dir) { if (list) list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' }); };
      var p = this.querySelector('[data-thumbs-prev]');
      var n = this.querySelector('[data-thumbs-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    }
  });

  /* ---------- Produkt: zestawy, kolory, dodatki, koszyk ---------- */
  define('product-section', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.bundles = Array.from(this.querySelectorAll('[data-bundle]'));
      this.button = this.querySelector('[data-add]');
      this.label = this.querySelector('[data-add-label]');
      this.error = this.querySelector('[data-error]');

      this.bundles.forEach((b) => {
        var radio = b.querySelector('.bundle__radio');
        radio.addEventListener('change', () => this.select(b));
        b.addEventListener('click', (e) => {
          if (e.target.closest('input, label, a, button')) return;
          radio.checked = true; this.select(b);
        });
        b.querySelectorAll('[data-item-row] input').forEach((i) => i.addEventListener('change', () => this.updatePrice(b)));
      });

      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });

      var sticky = this.querySelector('[data-sticky-atc]');
      var stickyBtn = this.querySelector('[data-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', () => this.add());
      if (sticky && this.button && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(this.button);
      }
    }

    selected() { return this.bundles.find((b) => b.querySelector('.bundle__radio').checked); }

    select(b) {
      this.bundles.forEach((x) => x.classList.toggle('is-selected', x === b));
      var qty = this.form && this.form.querySelector('[data-qty-input]');
      if (qty) qty.value = b.dataset.qty;
    }

    updatePrice(b) {
      var rows = b.querySelectorAll('[data-item-row]');
      if (!rows.length) return;
      var full = 0;
      rows.forEach(function (row) {
        var c = row.querySelector('input:checked');
        if (c) full += parseInt(c.dataset.price, 10);
      });
      var now = Math.round(full * (100 - parseInt(b.dataset.discount, 10)) / 100);
      var set = function (sel, v) { var el = b.querySelector(sel); if (el) el.textContent = formatMoney(v); };
      set('[data-now]', now);
      set('[data-full]', full);
      set('[data-saved]', full - now);
    }

    items() {
      var items = [];
      var b = this.selected();
      var baseId = this.form ? parseInt(this.form.querySelector('[data-variant-input]').value, 10) : null;
      var push = function (id, q) {
        id = parseInt(id, 10);
        var found = items.find(function (i) { return i.id === id; });
        if (found) found.quantity += q; else items.push({ id: id, quantity: q });
      };
      if (!b) { push(baseId, 1); return items; }
      var rows = b.querySelectorAll('[data-item-row]');
      if (rows.length) {
        rows.forEach(function (row) {
          var c = row.querySelector('input:checked');
          push(c ? c.value : baseId, 1);
        });
      } else {
        push(baseId, parseInt(b.dataset.qty, 10) || 1);
      }
      b.querySelectorAll('[data-upsell]:checked').forEach(function (u) { push(u.value, 1); });
      return items;
    }

    add() {
      if (!this.button || this.button.disabled) return;
      var original = this.label ? this.label.textContent : '';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      if (this.label) this.label.textContent = theme.strings.adding || '…';
      if (this.error) this.error.hidden = true;

      fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: this.items() })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || theme.strings.error);
            return data;
          });
        })
        .then(() => {
          if (theme.afterAdd === 'checkout') { window.location.href = theme.routes.root.replace(/\/$/, '') + '/checkout'; return; }
          var drawer = document.querySelector('cart-drawer');
          if (theme.afterAdd === 'drawer' && drawer && drawer.enabled) {
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
            if (this.label) this.label.textContent = original;
            drawer.refresh().then(function () { drawer.open(); });
            return;
          }
          if (theme.afterAdd === 'cart' || theme.afterAdd === 'drawer') { window.location.href = theme.routes.cart; return; }
          updateCartCount();
          if (this.label) this.label.textContent = theme.strings.added || original;
          setTimeout(() => { if (this.label) this.label.textContent = original; }, 2500);
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        })
        .catch((err) => {
          if (this.error) { this.error.textContent = err.message || theme.strings.error; this.error.hidden = false; }
          if (this.label) this.label.textContent = original;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        });
    }
  });

  /* ---------- Wysuwany koszyk ---------- */
  define('cart-drawer', class extends HTMLElement {
    connectedCallback() {
      this.enabled = this.dataset.enabled !== 'false';
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); this.close(); return; }
        var addBtn = e.target.closest('[data-cart-add]');
        if (addBtn) { this.addVariant(parseInt(addBtn.dataset.cartAdd, 10)); return; }
        var q = e.target.closest('[data-qty-change]');
        if (q) {
          var line = q.closest('[data-line]');
          this.change(parseInt(line.dataset.line, 10), parseInt(q.dataset.qtyChange, 10));
        }
      });
      this.addEventListener('change', (e) => {
        var t = e.target.closest('[data-addon-toggle]');
        if (!t) return;
        var line = t.closest('[data-line]');
        if (t.checked) this.addVariant(parseInt(t.dataset.addonToggle, 10));
        else if (line) this.change(parseInt(line.dataset.line, 10), 0);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      document.addEventListener('click', (e) => {
        var opener = e.target.closest('[data-cart-open]');
        if (!opener || !this.enabled) return;
        e.preventDefault();
        this.lastFocus = opener;
        this.open();
      });
    }
    open() {
      this.hidden = false;
      document.documentElement.classList.add('cart-open');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        var panel = this.querySelector('.cart-drawer__panel');
        if (panel) panel.focus({ preventScroll: true });
      });
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cart-open');
      setTimeout(() => { if (!this.classList.contains('is-open')) this.hidden = true; }, 300);
      if (this.lastFocus) this.lastFocus.focus();
    }
    render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-inner]');
      var inner = this.querySelector('[data-cart-inner]');
      if (fresh && inner) { inner.innerHTML = fresh.innerHTML; initCountdowns(inner); }
    }
    refresh() {
      var id = this.dataset.sectionId;
      return fetch(theme.routes.root.replace(/\/$/, '') + '/?sections=' + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then((data) => { if (data[id]) this.render(data[id]); updateCartCount(); })
        .catch(function () {});
    }
    addVariant(id) {
      this.classList.add('is-loading');
      return fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: [this.dataset.sectionId] })
      })
        .then(function (r) { return r.json(); })
        .then((data) => {
          if (data.sections && data.sections[this.dataset.sectionId]) { this.render(data.sections[this.dataset.sectionId]); updateCartCount(); }
          else return this.refresh();
        })
        .finally(() => this.classList.remove('is-loading'));
    }
    change(line, quantity) {
      this.classList.add('is-loading');
      return fetch(theme.routes.root.replace(/\/$/, '') + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity), sections: [this.dataset.sectionId] })
      })
        .then(function (r) { return r.json(); })
        .then((data) => {
          if (data.sections && data.sections[this.dataset.sectionId]) this.render(data.sections[this.dataset.sectionId]);
          else return this.refresh();
          updateCartCount();
        })
        .finally(() => this.classList.remove('is-loading'));
    }
  });

  function updateCartCount() {
    fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      })
      .catch(function () {});
  }

  /* ---------- Pokaz slajdów (mini opinie) ---------- */
  define('slide-show', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (this.slides.length < 2) return;
      this.i = 0;
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.i - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.i + 1); this.restart(); });
      this.dots.forEach((d, idx) => d.addEventListener('click', () => { this.go(idx); this.restart(); }));
      this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
      this.restart();
    }
    go(n) {
      var len = this.slides.length;
      this.i = (n + len) % len;
      this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.i));
      this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === this.i));
    }
    restart() { clearInterval(this.t); if (this.delay) this.t = setInterval(() => this.go(this.i + 1), this.delay); }
    disconnectedCallback() { clearInterval(this.t); }
  });

  /* ---------- Przewijana galeria z kropkami ---------- */
  define('scroll-slider', class extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      var dotsWrap = this.querySelector('[data-dots]');
      if (!track || !dotsWrap) return;
      var build = function () {
        var pages = Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var d = document.createElement('span');
          d.className = 'dots__dot' + (i === 0 ? ' is-active' : '');
          d.dataset.page = i;
          d.addEventListener('click', function () { track.scrollTo({ left: this.dataset.page * track.clientWidth, behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
        }
      };
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dotsWrap.querySelectorAll('.dots__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
      build();
      window.addEventListener('resize', build);
    }
  });

  /* ---------- Lista opinii: sortowanie i strony ---------- */
  define('review-list', class extends HTMLElement {
    connectedCallback() {
      this.wrap = this.querySelector('[data-items]');
      this.pagesEl = this.querySelector('[data-pages]');
      this.per = parseInt(this.dataset.perPage, 10) || 5;
      this.all = Array.from(this.querySelectorAll('[data-review]'));
      this.page = 1;
      var sort = this.querySelector('[data-sort]');
      if (sort) sort.addEventListener('change', () => { this.sort(sort.value); this.page = 1; this.render(); });
      this.sort('recent');
      this.render();
    }
    sort(mode) {
      var date = function (el) { return Date.parse(el.dataset.date) || 0; };
      var list = this.all.slice();
      if (mode === 'highest') list.sort(function (a, b) { return b.dataset.rating - a.dataset.rating || date(b) - date(a); });
      else if (mode === 'lowest') list.sort(function (a, b) { return a.dataset.rating - b.dataset.rating || date(b) - date(a); });
      else if (mode === 'photos') list.sort(function (a, b) { return b.dataset.photo - a.dataset.photo || date(b) - date(a); });
      else list.sort(function (a, b) { return date(b) - date(a) || a.dataset.index - b.dataset.index; });
      this.list = list;
      list.forEach((el) => this.wrap.appendChild(el));
    }
    render() {
      var pages = Math.ceil(this.list.length / this.per);
      var start = (this.page - 1) * this.per;
      this.list.forEach((el, i) => { el.hidden = i < start || i >= start + this.per; });
      this.pagesEl.innerHTML = '';
      if (pages < 2) return;
      var mk = (label, page, active, aria) => {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = label; if (aria) b.setAttribute('aria-label', aria);
        if (active) { b.classList.add('is-active'); b.setAttribute('aria-current', 'page'); }
        b.addEventListener('click', () => { this.page = page; this.render(); this.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        this.pagesEl.appendChild(b);
      };
      if (this.page > 1) mk('‹', this.page - 1, false, 'Poprzednia');
      for (var p = 1; p <= pages; p++) mk(String(p), p, p === this.page);
      if (this.page < pages) { mk('›', this.page + 1, false, 'Następna'); mk('»', pages, false, 'Ostatnia'); }
    }
  });

  /* ---------- Termin dostawy (dni robocze) ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var out = el.querySelector('[data-delivery-range]');
    var lang = document.documentElement.lang || 'pl';
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    var a = addBusinessDays(new Date(), parseInt(el.dataset.min, 10) || 0);
    var b = addBusinessDays(new Date(), parseInt(el.dataset.max, 10) || 0);
    try { out.textContent = a.toLocaleDateString(lang, opts) + ' – ' + b.toLocaleDateString(lang, opts); }
    catch (e) { out.textContent = a.toLocaleDateString() + ' – ' + b.toLocaleDateString(); }
  });

  /* ---------- Powiększanie zdjęć z opinii ---------- */
  var lb = document.querySelector('[data-lightbox-dialog]');
  if (lb) {
    var lbImg = lb.querySelector('[data-lightbox-img]');
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lightbox]');
      if (!t) return;
      lbImg.src = t.dataset.lightbox;
      var img = t.querySelector('img');
      lbImg.alt = img ? img.alt : '';
      lbImg.removeAttribute('width'); lbImg.removeAttribute('height');
      if (lb.showModal) lb.showModal(); else window.open(t.dataset.lightbox, '_blank');
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-lightbox-close]')) lb.close(); });
  }

  /* ---------- Menu mobilne ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) { btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  });
})();
